import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import type { KmatType } from "~/features/configurator/Linear/kmatType";
import { LCTileImage } from "~/features/configurator/Linear/components/LinearTile";
import { GET_GUIDEWAY_SET_IMAGE_URL } from "~/features/configurator/Linear/constants";
import {
  RailLocatingFaceSegment1,
  RailLocatingFaceSegment2,
} from "~/features/configurator/Linear/v2/configuration/kllt/KLLTUnitCstics";
import { selectCsticExpanded } from "~/features/configurator/Linear/redux/selectCstic";
import { SimpleCsticId } from "~/features/configurator/Linear/models";
import { SubstepType } from "~/features/configurator/Linear/dtos";
import { LinearSectionTitle } from "~/features/configurator/Linear/components/LinearSectionTitle";

interface Props {
  kmatType: KmatType;
  railAmount: number;
  railIndex: number;
}

export const KLLTGuidewaySetHeader: FC<Props> = ({ railAmount, railIndex }) => {
  const { t } = useTranslation();

  let locatingFaceCsticName;
  if (railIndex === 0) {
    locatingFaceCsticName = RailLocatingFaceSegment1;
  } else {
    locatingFaceCsticName = RailLocatingFaceSegment2;
  }
  const { cstic: locatingFaceCstic } = useSelector(
    selectCsticExpanded(SimpleCsticId(locatingFaceCsticName), SubstepType.LocatingFace),
  );

  return (
    <>
      <LCTileImage className={"w-100"} imageUrl={GET_GUIDEWAY_SET_IMAGE_URL(railAmount, railIndex + 1)} />
      <LinearSectionTitle className={"my-0"}>
        {t(`page.linear.guidewaySet.title.${locatingFaceCstic?.value == "U" ? "below" : "above"}`, {
          index: railIndex + 1,
        })}
      </LinearSectionTitle>
    </>
  );
};

export default KLLTGuidewaySetHeader;
